import { EventSummary } from "../modules/s25-swarm-schedule/s25.event.summary.service";
import DowChar = EventSummary.DowChar;
export namespace CustomAttributes {
    export const enum Type {
        Boolean = "B",
        Image = "I",
        LargeText = "X",
        Organization = 2,
        Contact = 3,
        Location = 4,
        Resource = 6,
        FileReference = "R",
        String = "S",
        Date = "D",
        Datetime = "E",
        Time = "T",
        Integer = "N",
        Float = "F",
        Duration = "L",
    }

    export const type = {
        DateTime: "E",
        Date: "D",
        Time: "T",
        Boolean: "B",
        Organization: 2,
        Location: 4,
        Resource: 6,
        Contact: 3,
        Float: "F",
        Integer: "N",
        Text: "S",
        LongText: "X",
        URL: "R",
        Image: "I",
    } as const;

    export const system = {
        termCode: { id: -50 }, // Can be either term code or term description
        sectionType: { id: -56 },
        subTerm: { id: -59 },
        uniqueSectionId: { id: -68 },
        syncPaused: { id: -72 },
        StudentHousingSeason: { id: -10_000 },
        AdmitPoolId: { id: -10_001 },
        studentEngagement: { id: -1000 },
        orgMission: { id: -1002 },
        orgImage: { id: -1001 },
        promotedEvent: { id: -4 }, // Student Engagement promoted event
        urlAttributeIds: {
            event_custom_attribute: [-1, -2, -20, -21, -80] as number[],
            location_custom_attribute: [-81] as number[],
            resource_custom_attribute: [-82] as number[],
        } as const, //  URL only no upload file option
    } as const;

    export type CustAttrObj = {
        custAttrId: number;
        imageId: number;
        itemId: number;
        itemLabel: string;
        itemName: string;
        itemTypeId: CustAttrCode;
        multi_val: boolean;
        sort_order: number;
        hasDiscreteOptions?: boolean;
    };

    export type CustAttrCode = (typeof type)[keyof typeof type];
    export type UrlAttributeType = "event_custom_attribute" | "location_custom_attribute" | "resource_custom_attribute";
    export type ConditionValue =
        | boolean
        | string
        | number
        | Date
        | ItemValue
        | Date[]
        | number[]
        | Record<DowChar, boolean>
        | { days: number; type: string }
        | ItemValue[];

    export type ItemValue = {
        itemId?: number | string;
        value?: string;
        itemName?: string; // Not present if operator is "in"
        itemTypeId?: number;
    };
}
